export class MobileSettings {
  requireLicensePhoto: boolean = false;
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/MobileSettings.ts